import { Navigate } from 'react-router-dom';
import { useUserStore } from '@/stores/user/userStore';

/**
 * Lightweight route guard that checks if a token exists without calling
 * refreshAccessToken(). Safe for pages opened in new tabs - avoids the
 * destructive chain where a failed refresh wipes localStorage auth
 * across all tabs.
 */
const TokenCheckRoute = ({ children }) => {
  const access_token = useUserStore((state) => state.auth?.access_token);

  return access_token ? children : <Navigate to="/log-in" replace />;
};

export default TokenCheckRoute;
